import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d3738662"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create_bg create_title" }
const _hoisted_2 = { class: "create_line" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "create_name height" }, "投票方式：", -1))
const _hoisted_4 = { class: "create_line" }
const _hoisted_5 = { class: "create_line" }
const _hoisted_6 = { class: "create_line" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "create_name height" }, [
  /*#__PURE__*/_createTextVNode("投票结果"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("是否公开：")
], -1))
const _hoisted_8 = { class: "create_line" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "create_name height" }, "投票样式", -1))
const _hoisted_10 = { style: {"display":"inline-block"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mask_tip" }, "建议图片尺寸960*540，2M以内", -1))
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "movers postion create_html" }
const _hoisted_14 = { class: "create_line marg" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "create_name height" }, "选项类型：", -1))
const _hoisted_16 = {
  key: 1,
  class: "create_line marg"
}
const _hoisted_17 = {
  key: 2,
  class: "create_line marg"
}
const _hoisted_18 = { class: "create_line marg" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "create_name" }, "问题名称：", -1))
const _hoisted_20 = { class: "create_name" }
const _hoisted_21 = { class: "create_form_wrap" }
const _hoisted_22 = {
  key: 0,
  class: "inline"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mask_tip" }, "建议图片尺寸960*540，2M以内", -1))
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "create_bot_but_box" }
const _hoisted_26 = { class: "create_bot_but_box" }

import http from '@/api/live';
// import { useRouter, useRoute } from 'vue-router';
import { InputNumber } from 'ant-design-vue';
import { Moment } from 'moment';
import { ref, computed } from 'vue';
import { Radio, Popover } from 'ant-design-vue';
import CUpload from '@/components/CUpload.vue';
import { QuestionCircleFilled, MinusCircleOutlined, PlusCircleOutlined, PlusOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { VueDraggableNext } from 'vue-draggable-next';
import { UploadOutlined } from '@ant-design/icons-vue';
import CDelModal from '@/components/CDelModal.vue';
import moment from 'moment';
import { dragDrop } from '@/utils/format/dragDrop';

interface QOpiton {
  select?: string;
  title: string;
  id?: string;
  img_url?: string;
}
interface IType {
  value: string;
  label: string;
}
interface IOption {
  title: string;
  select: string;
  select_num: string;
  select_least: string;
  options: QOpiton[];
  drop_down: IType[];
}
interface VoteForm {
  theme: string;
  end_at?: Moment | null;
  type: number;
  id?: number;
  popup: number;
  result: number;
  status: string;
  studio_id?: string;
  items: string;
  /** 0.默认 1.头图模式 */
  style: 0 | 1,
  head_image: string
}
interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: any;
  url?: string;
  originFileObj: never;
  type?: string;
  size: number;
}

interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}

const __default__ = { name: 'Create' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    dataSource: null
  },
  emits: ['createStatus'],
  setup(__props: any, { emit }) {

const props = __props as { dataSource: any };

const aRadioGroup = Radio.Group;
const aInputNumber = InputNumber;
const draggable = VueDraggableNext;
const aPopover = Popover;
// import routerid from '@/router';



const updataVote = ref<VoteForm>({
  theme: '',
  type: 0,
  popup: 0,
  result: 0,
  status: '',
  studio_id: '',
  items: '',
  style: 0,
  head_image: ''
});
const items = ref<IOption[]>([]);

const isShowImg = computed(() => updataVote.value.type === 1);
const getVoteView = () => {
  const data = {
    id: props.dataSource.voteId,
  };
  http.getVoteView({ params: data }).then((res) => {
    updataVote.value = res.data.data;
    if (res.data.data.end_at) {
      updataVote.value.end_at = moment(res.data.data.end_at);
    }
    const arr = JSON.parse(res.data.data.items);
    items.value = arr.map((e: any) => {
      e.select = e.select ? e.select : '1';
      e.select_least = e.select_least || 1;
      return e;
    });
  });
};
if (props.dataSource.voteId) {
  getVoteView();
} else {
  items.value.push({
    title: '',
    select: '1',
    select_num: '1',
    select_least: '1',
    options: [
      { title: '', img_url: '', select: '' },
      { title: '', img_url: '', select: '' },
    ],
    drop_down: [
      { value: '1', label: '单选' },
      { value: '2', label: '多选' },
    ],
  });
}
const select_blur = (select_num: string, length: any) => {
  // console.log('123', select_num);
  if (select_num === '1') {
    message.error('最多选择数量不能少于1个!');
  } else if (select_num > length) {
    message.error('最多选择数量不能大于选项数量!');
  }
};
const dragOptions = {
  animation: 500,
  group: 'description',
  // disabled: false,
  ghostClass: 'ghost',
};

const createVote = () => {
  items.value.push({
    title: '',
    select: '1',
    select_num: '1',
    select_least: '1',
    options: [
      { title: '', img_url: '', select: '' },
      { title: '', img_url: '', select: '' },
    ],
    drop_down: [
      { value: '1', label: '单选' },
      { value: '2', label: '多选' },
    ],
  });
};
const delVisible = ref<boolean>(false);
const delIndex = ref();
const openDelModal = () => {
  delVisible.value = !delVisible.value;
};
// 确定删除
const okDelModal = () => {
  items.value.splice(delIndex.value, 1);
  openDelModal();
};
// 删除
const delVote = (index: number) => {
  delIndex.value = index;
  delVisible.value = true;
};
// 添加
const createOption = (index: number) => {
  items.value[index].options.push({
    title: '',
    select: '',
    img_url: '',
  });
};

// 表单编辑
// const studio_id = props.dataSource.studioId;
const dateFormat = (time: any) => {
  var date = new Date(time);
  var year = date.getFullYear();
  /* 在日期格式中，月份是从0开始的，因此要加0
   * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
   * */
  var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
  var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
  var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
  var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
  // 拼接 format="YYYY-MM-DD hh:mm:ss"
  return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
};
const subForm = () => {
  const formData: any = {
    end_at: updataVote.value.end_at ? dateFormat(updataVote.value.end_at) : '',
    id: updataVote.value.id,
    items: JSON.stringify(items.value),
    popup: updataVote.value.popup,
    result: updataVote.value.result,
    status: updataVote.value.status,
    studio_id: props.dataSource.studioId,
    theme: updataVote.value.theme,
    type: updataVote.value.type,
    style: updataVote.value.style
  };
  if (updataVote.value.style === 1) {
    formData.head_image = updataVote.value.head_image
    if (!formData.head_image) {
      message.warn('请上传头图')
      return
    }
  }
  if (props.dataSource.voteId) {
    http
      .voteUpdate(formData)
      .then((res) => {
        emit('createStatus', false);
        message.success(res.data.message);
        // router.push({ name: 'Vote' });
      })
      .catch((res) => {
        message.error(res.data.error);
        // message.error(res.data.message);
      });
  } else {
    http
      .createVote(formData)
      .then((res) => {
        emit('createStatus', false);
        message.success(res.data.message);
      })
      .catch((res) => {
        message.error(res.data.error);
        // message.error(res.data.message);
      });
  }
};

const delOption = (index: number, i: number) => {
  items.value[index].options.splice(i, 1);
};

const images = ref([]);
const head_images = ref([])
const loading1 = ref();
const handleChange1 = (info: FileInfo, index: number, i: number) => {
  if (info.file?.response?.code === 200) {
    message.success(info.file?.response?.message);
    updataVote.value.head_image = info.file?.response?.data.url
  } else if (info.file.status === 'error') {
    message.error(info.file?.response?.error);
  } else if (info.file.status === 'uploading') {
    loading1.value = true;
    return;
  } else loading1.value = false;
};
const loading = ref();
// 上传
const handleChange = (info: FileInfo, index: number, i: number) => {
  if (info.file?.response?.code === 200) {
    message.success(info.file?.response?.message);
    items.value[index].options[i].img_url = info.file?.response?.data.url;
  } else if (info.file.status === 'error') {
    message.error(info.file?.response?.error);
  } else if (info.file.status === 'uploading') {
    loading.value = true;
    return;
  } else loading.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_unref(aRadioGroup), {
        value: updataVote.value.type,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((updataVote.value.type) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_radio, { value: 0 }, {
            default: _withCtx(() => [
              _createTextVNode("文字投票")
            ]),
            _: 1
          }),
          _createVNode(_component_a_radio, { value: 1 }, {
            default: _withCtx(() => [
              _createTextVNode("图文投票")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, [
        _createTextVNode(" 投票主题： "),
        _createVNode(_component_a_input, {
          value: updataVote.value.theme,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((updataVote.value.theme) = $event)),
          placeholder: "请输入投票主题",
          class: "create_form"
        }, null, 8, ["value"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", null, [
        _createTextVNode(" 截止时间： "),
        _createVNode(_component_a_date_picker, {
          value: updataVote.value.end_at,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((updataVote.value.end_at) = $event)),
          class: "cache_top_picker create_form",
          size: "large",
          "show-time": "",
          placeholder: "请输入截止时间"
        }, {
          suffixIcon: _withCtx(() => [
            _createVNode(_component_svg_icon, {
              class: "range_picker_icon",
              "icon-class": "icon_time"
            })
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createVNode(_unref(aRadioGroup), {
        value: updataVote.value.result,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((updataVote.value.result) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_radio, { value: 1 }, {
            default: _withCtx(() => [
              _createTextVNode("是")
            ]),
            _: 1
          }),
          _createVNode(_component_a_radio, { value: 0 }, {
            default: _withCtx(() => [
              _createTextVNode("否")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createVNode(_unref(aRadioGroup), {
        value: updataVote.value.style,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((updataVote.value.style) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_radio, { value: 0 }, {
            default: _withCtx(() => [
              _createTextVNode("默认")
            ]),
            _: 1
          }),
          _createVNode(_component_a_radio, { value: 1 }, {
            default: _withCtx(() => [
              _createTextVNode("头图")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"]),
      _withDirectives(_createElementVNode("div", _hoisted_10, [
        _createVNode(CUpload, {
          "file-list": head_images.value,
          "handle-change": (info) => handleChange1(info, _ctx.index, _ctx.i),
          plus: false,
          class: "ant_upload"
        }, {
          uploadImg: _withCtx(() => [
            _createVNode(_component_a_button, { class: "upload" }, {
              default: _withCtx(() => [
                _createVNode(_unref(UploadOutlined)),
                _createTextVNode("上传图片")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["file-list", "handle-change"])
      ], 512), [
        [_vShow, updataVote.value.style === 1]
      ]),
      (updataVote.value.style === 1)
        ? (_openBlock(), _createBlock(_unref(aPopover), {
            key: 0,
            placement: "right",
            class: "icon_tip"
          }, {
            content: _withCtx(() => [
              _hoisted_11
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(QuestionCircleFilled), { class: "QuestionCircleFilled" })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (updataVote.value.style === 1 && updataVote.value.head_image)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: updataVote.value.head_image,
            alt: "",
            class: "up_img"
          }, null, 8, _hoisted_12))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(draggable), _mergeProps({
      handle: ".movers",
      class: "dragArea list-group w-full",
      disabled: items.value.length < 1,
      list: items.value
    }, dragOptions, { onDrop: _unref(dragDrop) }), {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "create_bor border postion_r"
          }, [
            (items.value.length > 1)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  shape: "circle",
                  onClick: ($event: any) => (delVote(index)),
                  class: "create_icon mover"
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_svg_icon, {
                      class: "mod_btn_icon",
                      "icon-class": "del"
                    })
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("span", _hoisted_13, [
              _createVNode(_component_svg_icon, { "icon-class": "drag_icon" })
            ], 512), [
              [_vShow, items.value.length > 1]
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_unref(aRadioGroup), {
                value: item.select,
                "onUpdate:value": ($event: any) => ((item.select) = $event)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio, { value: "1" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 单选")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_radio, { value: "2" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 多选")
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["value", "onUpdate:value"])
            ]),
            (item.select === '2')
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", null, [
                    _createTextVNode(" 最多选择： "),
                    _createVNode(_unref(aInputNumber), {
                      id: "inputNumber",
                      type: "number",
                      value: item.select_num,
                      "onUpdate:value": ($event: any) => ((item.select_num) = $event),
                      min: Number(item.select_least),
                      max: item.options.length,
                      size: "default",
                      class: "create_form create_num"
                    }, null, 8, ["value", "onUpdate:value", "min", "max"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (item.select === '2')
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", null, [
                    _createTextVNode(" 至少选择： "),
                    _createVNode(_unref(aInputNumber), {
                      id: "inputNumber",
                      type: "number",
                      value: item.select_least,
                      "onUpdate:value": ($event: any) => ((item.select_least) = $event),
                      min: 1,
                      max: Number(item.select_num),
                      size: "default",
                      class: "create_form create_num"
                    }, null, 8, ["value", "onUpdate:value", "max"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode(_component_a_input, {
                value: item.title,
                "onUpdate:value": ($event: any) => ((item.title) = $event),
                placeholder: "请输入问题名称",
                class: "create_form"
              }, null, 8, ["value", "onUpdate:value"])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (o, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "create_line marg postion_r"
              }, [
                _createElementVNode("div", _hoisted_20, "选项" + _toDisplayString(i + 1) + "：", 1),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_a_input, {
                    value: o.title,
                    "onUpdate:value": ($event: any) => ((o.title) = $event),
                    placeholder: "请输入选项内容",
                    class: "create_form"
                  }, null, 8, ["value", "onUpdate:value"]),
                  _createVNode(_component_a_button, {
                    shape: "circle",
                    onClick: ($event: any) => (delOption(index, i)),
                    class: "create_icon create_html create_form_btn"
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_unref(MinusCircleOutlined))
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                (_unref(isShowImg))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createVNode(CUpload, {
                        "file-list": images.value,
                        "handle-change": (info) => handleChange(info, index, i),
                        plus: false,
                        class: "ant_upload"
                      }, {
                        uploadImg: _withCtx(() => [
                          _createVNode(_component_a_button, { class: "upload" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(UploadOutlined)),
                              _createTextVNode("上传图片")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["file-list", "handle-change"])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(isShowImg))
                  ? (_openBlock(), _createBlock(_unref(aPopover), {
                      key: 1,
                      placement: "right",
                      class: "icon_tip"
                    }, {
                      content: _withCtx(() => [
                        _hoisted_23
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_unref(QuestionCircleFilled), { class: "QuestionCircleFilled" })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (o.img_url && _unref(isShowImg))
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 2,
                      src: o.img_url,
                      alt: "",
                      class: "up_img"
                    }, null, 8, _hoisted_24))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            _createVNode(_component_a_button, {
              shape: "circle",
              onClick: ($event: any) => (createOption(index)),
              class: "create_icon create_html"
            }, {
              icon: _withCtx(() => [
                _createVNode(_unref(PlusCircleOutlined))
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]))
        }), 128))
      ]),
      _: 1
    }, 16, ["disabled", "list", "onDrop"]),
    _createVNode(CDelModal, {
      visible: delVisible.value,
      centered: "",
      close: openDelModal,
      ok: okDelModal
    }, null, 8, ["visible"]),
    _createElementVNode("div", _hoisted_25, [
      _createVNode(_component_a_button, {
        shape: "circle",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (createVote())),
        class: "create_bot_bor create_bot_but"
      }, {
        icon: _withCtx(() => [
          _createVNode(_unref(PlusOutlined))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createVNode(_component_a_button, {
        type: "primary",
        class: "create_bot_but",
        onClick: subForm
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 保存")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})